import axios from "axios";
import { API_BASE_URL, getAuthConfig } from "./apiClient";
import {
  formatBirthdateForApi,
  isValidCertificateId,
} from "../util/certificateHelpers";

export const verifyCertificate = async (certificateId, dateOfBirth) => {
  const trimmedCertificateId = certificateId?.trim();

  if (!isValidCertificateId(trimmedCertificateId)) {
    throw new Error("Invalid certificate ID. Enter a valid UUID.");
  }

  const formattedBirthdate = formatBirthdateForApi(dateOfBirth);

  if (!formattedBirthdate) {
    throw new Error("Date of birth is required for verification.");
  }

  const response = await axios.post(`${API_BASE_URL}/certificates/verify`, {
    certificateId: trimmedCertificateId,
    dateOfBirth: formattedBirthdate,
  });

  return response.data;
};

export const fetchCertificate = async (certificateId, dateOfBirth) => {
  const trimmedCertificateId = certificateId?.trim();

  if (!isValidCertificateId(trimmedCertificateId)) {
    throw new Error("Invalid certificate ID. Enter a valid UUID.");
  }

  const formattedBirthdate = formatBirthdateForApi(dateOfBirth);

  if (!formattedBirthdate) {
    throw new Error("Date of birth is required for verification.");
  }

  const response = await axios.get(
    `${API_BASE_URL}/certificates/${encodeURIComponent(trimmedCertificateId)}`,
    { params: { dateOfBirth: formattedBirthdate } },
  );

  return response.data;
};

export const fetchCertificateList = async () => {
  const response = await axios.get(
    `${API_BASE_URL}/certificates`,
    getAuthConfig(),
  );

  return response.data?.items || [];
};

export const createCertificate = async (payload) => {
  const response = await axios.post(
    `${API_BASE_URL}/certificates`,
    payload,
    getAuthConfig(),
  );

  return response.data;
};

export const updateCertificate = async (certificateId, payload) => {
  if (!isValidCertificateId(certificateId)) {
    throw new Error("Invalid certificate ID. Admin actions require a UUID.");
  }

  const response = await axios.put(
    `${API_BASE_URL}/certificates/${encodeURIComponent(certificateId.trim())}`,
    payload,
    getAuthConfig(),
  );

  return response.data;
};

export const deleteCertificate = async (certificateId) => {
  if (!isValidCertificateId(certificateId)) {
    throw new Error("Invalid certificate ID. Admin actions require a UUID.");
  }

  await axios.delete(
    `${API_BASE_URL}/certificates/${encodeURIComponent(certificateId.trim())}`,
    getAuthConfig(),
  );
};
